import logoImg from './assets/img/logo.webp';
import bg1Img from './assets/img/bg1.webp';
import pic1Img from './assets/img/pic1.webp';
import pic2Img from './assets/img/pic2.webp';

import loaderAnim from './assets/img/cherry blossom brunch grow.json';
import heartAnim from './assets/img/Heart Baloon.json';
import handshakeAnim from './assets/img/handshake.json';
import contactAnim from './assets/img/contact us.json';

export const assets = {
  img: {
    logo: logoImg,
    bg1: bg1Img,
    pic1: pic1Img,
    pic2: pic2Img
  },
  anim: {
    loader: loaderAnim,
    heart: heartAnim,
    handshake: handshakeAnim,
    contact: contactAnim
  }
};